/**
 * Design tokens — single source of truth for all visual decisions.
 * Every component imports from here. Nothing is hard-coded inline.
 */

/** Colour palette */
export const C = {
  // Brand
  navy:        '#0F2040',
  navyDeep:    '#070F24',
  blue:        '#1D4ED8',
  blueMid:     '#2563EB',
  blueDark:    '#1E40AF',
  blueLight:   '#EFF6FF',
  amber:       '#F59E0B',
  amberDark:   '#D97706',
  amberLight:  '#FEF3C7',
  amberBorder: '#FDE68A',
  green:       '#10B981',
  whatsapp:    '#25D366',
  whatsappDk:  '#1EB858',
  // Neutrals
  bg:          '#F8FAFC',
  white:       '#FFFFFF',
  border:      '#E2E8F0',
  borderLight: '#F1F5F9',
  text:        '#1E293B',
  textMid:     '#475569',
  textMuted:   '#64748B',
  textLight:   '#94A3B8',
};

/** Font families */
export const F = {
  heading: "'Sora', sans-serif",
  body:    "'DM Sans', sans-serif",
};

/** Gradients */
export const G = {
  blue:      'linear-gradient(135deg, #1D4ED8 0%, #2563EB 100%)',
  blueHover: 'linear-gradient(135deg, #1E40AF 0%, #1D4ED8 100%)',
  navyBlue:  'linear-gradient(135deg, #1D4ED8 0%, #0F2040 100%)',
  hero:      'linear-gradient(160deg, #EFF6FF 0%, #F8FAFC 55%, #FEF3C7 100%)',
  dark:      'linear-gradient(135deg, #0F2040 0%, #1a2e4a 100%)',
};

/** Box shadows */
export const SH = {
  card:          '0 4px 24px rgba(15,32,64,0.06)',
  cardHover:     '0 12px 40px rgba(15,32,64,0.12)',
  form:          '0 20px 60px rgba(15,32,64,0.10)',
  modal:         '0 24px 80px rgba(0,0,0,0.20)',
  btnBlue:       '0 6px 20px rgba(29,78,216,0.32)',
  btnBlueHover:  '0 8px 28px rgba(29,78,216,0.45)',
  btnAmber:      '0 4px 14px rgba(245,158,11,0.35)',
  btnAmberHover: '0 4px 18px rgba(245,158,11,0.50)',
  btnGreen:      '0 8px 28px rgba(37,211,102,0.40)',
  btnGreenHover: '0 10px 32px rgba(37,211,102,0.55)',
};
